
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrend as ObiTrendElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-trend.js';
 
 
 

 
 export const ObiTrend = createComponent({
   react: React,
   tagName: 'obi-trend',
   elementClass: ObiTrendElement,
   events: {
     
   }
  });
 
 